export const isProduction = () => process.env.NODE_ENV === 'production';

export const capitalise = (value: string) =>
  value.charAt(0).toUpperCase() + value.slice(1);

/**
 * Turns a functions of any arity into a function that accepts exactly 2 args.
 * All other args will not be used.
 */
export const binary =
  <T extends (...args: any) => any>(fn: T) =>
  (x: any, y: any): ReturnType<T> =>
    fn(x, y);
